import React from 'react';

export const DashboardContentWrapper = ({ children, maxWidth = 700 }: {
    children: React.ReactNode;
    maxWidth?: number | string;
}) => {
  return <div style={{maxWidth: `${maxWidth}px`}} className='box-border w-full px-8 md:!px-8 lg:!px-12'>{children}</div>;
};
